import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Dropdown } from 'react-bootstrap';

export function AppHeader({ toggleSidebar }: { toggleSidebar: () => void }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <header className="navbar navbar-expand navbar-light bg-body border-bottom sticky-top px-3">
            <div className="d-flex align-items-center">
                <button
                    className="btn btn-link text-body p-0 me-3 d-md-none"
                    onClick={toggleSidebar}
                    aria-label="Toggle sidebar"
                >
                    <i className="bi bi-list fs-4"></i>
                </button>
                <Link to="/" className="navbar-brand fw-bold text-primary m-0">
                    PlaylistR
                </Link>
            </div>

            <div className="flex-grow-1"></div>

            <Dropdown align="end">
                <Dropdown.Toggle variant="light" id="dropdown-basic" className="d-flex align-items-center border-0 bg-transparent p-0 no-caret">
                    <div className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white me-2" style={{ width: 32, height: 32 }}>
                        {user?.name?.charAt(0).toUpperCase() || <i className="bi bi-person"></i>}
                    </div>
                    <span className="d-none d-sm-inline">{user?.name}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="/profile">Profile</Dropdown.Item>
                    <Dropdown.Item as={Link} to="/settings">Settings</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout} className="text-danger">Sign out</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </header>
    );
}
